import { StyleSheet, ViewStyle } from 'react-native'

import { SPACING_SM } from '@common/styles/spacings'
import { ThemeProps } from '@common/styles/themeConfig'
import flexbox from '@common/styles/utils/flexbox'
import { getUiType } from '@web/utils/uiType'

interface Style {
  container: ViewStyle
  grid: ViewStyle
  mainColumn: ViewStyle
  sidePanel: ViewStyle
}

export const NEUTRAL_BACKGROUND = '#1418333D'
export const NEUTRAL_BACKGROUND_HOVERED = '#14183352'
export const DASHBOARD_OVERVIEW_BACKGROUND = '#353d6e'

// Two-column full-tab grid. Same numbers as the web app's desktop home grid
// (LAYOUT in @mobile/modules/dashboard/screens/home/tokens) — kept local so
// common/ doesn't import from @mobile/, same technique as toastContext.
export const DASHBOARD_MAIN_COLUMN_WIDTH = 720
export const DASHBOARD_SIDE_PANEL_WIDTH = 408
export const DASHBOARD_GRID_GAP = 24

const { isTab } = getUiType()

const getStyles = (theme: ThemeProps) =>
  StyleSheet.create<Style>({
    container: {
      ...flexbox.flex1,
      // The page surface behind the cards. In the full-page tab it must be the
      // same token the web app paints (`homePageBackground`), not
      // primaryBackground: the cards on this screen use `homeCardBackground`,
      // which in LIGHT mode is the exact #FFFFFF primaryBackground has — so the
      // panels dissolved into the page. Matches TransactionsScreen (Send /
      // Shield / Unshield). The popup keeps its own surface.
      backgroundColor: isTab ? theme.homePageBackground : theme.primaryBackground
    },
    // Row wrapper for the tab layout: fixed-width main column + fixed-width side
    // panel, centered as a pair — the same proportions as the web desktop home.
    grid: {
      ...flexbox.flex1,
      ...flexbox.directionRow,
      ...flexbox.justifyCenter,
      width: '100%',
      alignSelf: 'center'
    },
    mainColumn: {
      ...flexbox.flex1,
      maxWidth: DASHBOARD_MAIN_COLUMN_WIDTH
    },
    sidePanel: {
      width: DASHBOARD_SIDE_PANEL_WIDTH,
      flexGrow: 0,
      flexShrink: 0,
      marginLeft: DASHBOARD_GRID_GAP,
      // Mirrors the main column's ptSm + the dashboard card's phSm window inset.
      paddingTop: SPACING_SM,
      paddingRight: SPACING_SM
    }
  })

export default getStyles
